import { render, staticRenderFns } from "./NgTime.vue?vue&type=template&id=70482f4a"
import script from "./NgTime.vue?vue&type=script&lang=js"
export * from "./NgTime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports